import gql from 'graphql-tag';

import DAILY_EXPANDED_FRAGMENT from './DAILY_EXPANDED_FRAGMENT';

const REMOVE_MACHINE_FROM_SERVICE_RUN_DAILY = gql`
	mutation removeMachineFromServiceRun (
		$machineId: ID!,
		$serviceRunId: ID!,
	) {
		removeMachineFromServiceRun (
			machineId: $machineId,
			serviceRunId: $serviceRunId,
		) {
			...serviceRunDailyExpanded
		}
	}
	${DAILY_EXPANDED_FRAGMENT}
`;

export default REMOVE_MACHINE_FROM_SERVICE_RUN_DAILY;
